import React, { Component } from "react";
import moment from "moment";
import Swal from "sweetalert2";
import { Button, Divider } from "@material-ui/core";

import CustomDialog from "../layout/CustomDialog";
import CalculatorIcon from "../layout/CalculatorIcon";
import LabeledTextField from "../layout/LabeledTextField";
import dealService from "../../services/dealsService";

class CalculatorDialog extends Component {
  state = {
    startDate: "",
    endDate: "",
    shekelAmount: null,
    startActualMadadDate: "",
    startActualMadadValue: null,
    endActualMadadDate: "",
    endActualMadadValue: null,
    shekelMemudadAmount: null,
    changingPercent: null
  };

  render() {
    return (
      <CustomDialog
        label="מחשבון מדד"
        open={this.props.open}
        onClose={this.props.onClose}
        maxWidth="xs"
        paperClassName="index-calculator-dialog"
        paperStyle={{ width: 460, maxWidth: "calc(100vw - 48px)" }}
        isContentDivided={false}
        titleAlign="center"
      >
        <div className="index-calculator-body">
          <div className="index-calculator-inputs">
            <LabeledTextField
              type="date"
              value={this.state.startDate}
              name="startDate"
              label="תחילת תקופה"
              labelWidth={120}
              textFieldWidth={160}
              onChange={(e) => this.handleOnChange(e)}
            />
            <LabeledTextField
              type="date"
              value={this.state.endDate}
              name="endDate"
              label="סיום תקופה"
              labelWidth={120}
              textFieldWidth={160}
              onChange={(e) => this.handleOnChange(e)}
            />
            <LabeledTextField
              type="number"
              value={this.state.shekelAmount}
              name="shekelAmount"
              label='הסכום בש"ח'
              labelWidth={120}
              textFieldWidth={160}
              currency="₪"
              onChange={(e) => this.handleOnChange(e)}
            />
            <div className="index-calculator-action">
              <Button
                className="index-calculator-calc-btn"
                variant="contained"
                onClick={() => this.getCalculatedMadad()}
                endIcon={<CalculatorIcon />}
              >
                חשב
              </Button>
            </div>
          </div>

          <Divider className="index-calculator-divider" />

          <div className="index-calculator-results">
            <div className="index-calculator-result">
              <LabeledTextField
                type="text"
                labeledTextFieldDirection="column"
                label="חודש קובע למדד:"
                textFieldWidth={160}
                disabled
                value={this.state.startActualMadadDate}
              />
            </div>
            <div className="index-calculator-result">
              <LabeledTextField
                type="number"
                labeledTextFieldDirection="column"
                label="ערך מדד בתאריך:"
                textFieldWidth={160}
                disabled
                value={this.state.startActualMadadValue}
              />
            </div>
            <div className="index-calculator-result">
              <LabeledTextField type="text" textFieldWidth={160} disabled value={this.state.endActualMadadDate} />
            </div>
            <div className="index-calculator-result">
              <LabeledTextField type="number" textFieldWidth={160} disabled value={this.state.endActualMadadValue} />
            </div>
            <div className="index-calculator-result">
              <LabeledTextField
                type="number"
                labeledTextFieldDirection="column"
                label='הסכום בש"ח ממודד:'
                textFieldWidth={130}
                disabled
                value={this.state.shekelMemudadAmount}
                currency="₪"
              />
            </div>
            <div className="index-calculator-result">
              <LabeledTextField
                type="number"
                labeledTextFieldDirection="column"
                label="השינוי באחוזים:"
                textFieldWidth={130}
                disabled
                value={this.state.changingPercent}
                currency="%"
              />
            </div>
          </div>
        </div>
      </CustomDialog>
    );
  }

  handleOnChange = (e) => {
    const newState = { ...this.state, [e.target.name]: e.target.value };
    this.setState(newState);
  };

  madadValidations() {
    if (!this.state.startDate) {
      return "תחילת תקופה הינו שדה חובה";
    } else if (this.state.startDate > moment(new Date()).format("YYYY-MM-DD")) {
      return "תחילת תקופה לא יכול להיות תאריך עתידי";
    } else if (!this.state.endDate) {
      return "סיום תקופה הינו שדה חובה";
    } else if (this.state.endDate > moment(new Date()).format("YYYY-MM-DD")) {
      return "סיום תקופה לא יכול להיות תאריך עתידי";
    } else if (this.state.startDate > this.state.endDate) {
      return "תאריך תחילת תקופה לא יכול להיות לאחר תאריך סיום תקופה";
    } else if (!this.state.shekelAmount) {
      return 'הסכום בש"ח הינו שדה חובה';
    }
    return null;
  }

  getCalculatedMadad() {
    const validationErr = this.madadValidations();
    if (validationErr) {
      return Swal.fire("", validationErr, "error");
    } else {
      dealService
        .getCalculatedMadad(this.state.startDate, this.state.endDate, this.state.shekelAmount)
        .then((res) => {
          if (res.success) {
            const {
              startActualMadadValue,
              startActualMadadDate,
              endActualMadadValue,
              endActualMadadDate,
              shekelMemudadAmount,
              changingPercent
            } = res.data;
            this.setState({
              startActualMadadValue,
              startActualMadadDate,
              endActualMadadValue,
              endActualMadadDate,
              shekelMemudadAmount,
              changingPercent
            });
          }
        })
        .catch((err) => {
          return Swal.fire("", err, "error");
        });
    }
  }
}

export default CalculatorDialog;
